import { familyPassesFilter, getFilter } from '../lib/constants/font-style-data'
import { shuffleArray } from '../lib/helpers/array'
import { selectFontVariantsForPreloading } from '../lib/helpers/fonts'

export const state = () => ({
  wordmark_fonts: [],
  slogan_fonts: [],
  // font weight range MUST include 400
  wordmark_font_filters: {
    exclude_styles: ['handwriting', 'monospace'],
    style: 'normal',
    min_font_weight: 100,
    max_font_weight: 900,
  },
  slogan_font_filters: {
    exclude_styles: ['handwriting', 'monospace'],
    style: 'normal',
    min_font_weight: 300,
    max_font_weight: 500,
  },
  font_binaries: {},
})

export const mutations = {
  addWordmarkFonts(state, value) {
    state.wordmark_fonts.push(...value)
  },

  addSloganFonts(state, value) {
    state.slogan_fonts.push(...value)
  },
  setWordmarkFonts(state, value) {
    state.wordmark_fonts = value
  },

  setSloganFonts(state, value) {
    state.slogan_fonts = value
  },
  clearFonts(state) {
    state.wordmark_fonts = []
    state.slogan_fonts = []
  },
  addFontBinary(state, { id, buffer }) {
    state.font_binaries[id] = buffer
  },
}

export const getters = {
  getBinary: state => id => {
    if (state.font_binaries[id]) return state.font_binaries[id]
    return null
  },
  themedFonts: (state, getters, rootState) => {
    const { fonts, font_categories } = rootState.editor
    const result = []
    font_categories.forEach(category => {
      const valid_fonts = fonts.filter(f => familyPassesFilter(f, category))
      const { max_font_weight, min_font_weight } = getFilter(category)
      const selected_variants = selectFontVariantsForPreloading(valid_fonts, {
        max_font_weight,
        min_font_weight,
        style: 'normal',
      })
      shuffleArray(selected_variants)
      result.push(...selected_variants)
    })
    shuffleArray(result)
    return result
  },
  validFontFamilies: (state, getters, rootState) => filters => {
    const { fonts } = rootState.editor
    return fonts.filter(family => {
      const {
        category: { name },
      } = family
      const is_excluded_category = filters.exclude_styles.includes(name)
      return !is_excluded_category
    })
  },

  validWordmarkFontFamilies(state, getters) {
    return getters.validFontFamilies(state.wordmark_font_filters)
  },
  validSloganFontFamilies(state, getters) {
    return getters.validFontFamilies(state.slogan_font_filters)
  },
}

export const actions = {
  selectValidFonts({ state, getters, rootState, commit }) {
    const font_families = rootState.editor.fonts
    if (font_families.length === 0) return

    let selected_wordmark_fonts
    if (
      rootState.editor.font_categories &&
      rootState.editor.font_categories.length !== 0
    ) {
      selected_wordmark_fonts = getters.themedFonts
    } else {
      selected_wordmark_fonts = selectFontVariantsForPreloading(
        getters.validWordmarkFontFamilies,
        state.wordmark_font_filters
      )
    }

    const selected_slogan_fonts = selectFontVariantsForPreloading(
      getters.validSloganFontFamilies,
      state.slogan_font_filters
    )

    shuffleArray(selected_slogan_fonts)
    shuffleArray(selected_wordmark_fonts)

    commit('setWordmarkFonts', selected_wordmark_fonts)
    commit('setSloganFonts', selected_slogan_fonts)
  },
}
